import {CONFIG} from 'src/config';

export default {
    write: (key, data) => {
        const tmp = localStorage.getItem(CONFIG.localStorageDisk);
        let objTMP = {};

        if (tmp) {
            try {
                objTMP = JSON.parse(tmp);
                objTMP[key] = data;
            }
            catch (e) {
                objTMP = {};
            }
        }
        // save object with key
        objTMP[key] = data;
        localStorage.setItem(CONFIG.localStorageDisk, JSON.stringify(objTMP));
    },
    read: (key) => {
        const tmp = localStorage.getItem(CONFIG.localStorageDisk);
        let objTMP = {};

        if (tmp) {
            try {
                objTMP = JSON.parse(tmp);
                if (typeof objTMP[key] !== 'undefined') {
                    return objTMP[key];
                }
            }
            catch (e) {
                return null;
            }
        }
        else {
            return null;
        }
    },
    clearDisk: () => {
        localStorage.setItem(CONFIG.localStorageDisk, null);
    }
}
